import { Routes } from '@angular/router';
import { AuthGuardService } from './services/guards/auth-guard.service';

import { AdminPageComponent } from './components/pages/admin-page/admin-page.component';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { IndividualUsersComponent } from './components/pages/individual-users/individual-users.component';
import { CorporateUsersComponent } from './components/pages/corporate-users/corporate-users.component';
import { AnalysisCountComponent } from './components/pages/analysis-count/analysis-count.component';

export const routes: Routes = [

    // Admin page (default)
    { path: '', component: AdminPageComponent, canActivate: [AuthGuardService] }, 

    // Login page - /login
    { path: 'login', component: LoginPageComponent },

    // Invidiaul users page - /individual-users
    { path: 'individual-users', component: IndividualUsersComponent, canActivate: [AuthGuardService] }, 

    // Corporate users page - /corporate-users
    { path: 'corporate-users', component: CorporateUsersComponent, canActivate: [AuthGuardService] },
    
    // Analysis count page - /analysis-count
    { path: 'analysis-count', component: AnalysisCountComponent, canActivate: [AuthGuardService] },
];
